


































import { Vue, Component } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import VideoPlayer from "@/components/GrammarToGo/VideoPlayer.vue";

import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import { AxiosError } from "axios";
import { IGrammarVideo } from "@/models/interfaces/grammar-to-go";

import RequestState from "@/utils/mixins/RequestState";

@Component({
  components: {
    AppContent,
    AppHeaderBackWithTitle,
    AppHeader,

    BaseSpinner,
    BaseAlert,
    VideoPlayer
  },

  mixins: [RequestState]
})
export default class VideoPlay extends Vue {
  @State("video", { namespace: "grammarToGo" })
  private video!: IVuexState<IGrammarVideo>;

  @Action("grammarToGo/fetchVideo")
  private fetchVideo!: (videoId: string) => Promise<AxiosError | IGrammarVideo>;

  private src = "";

  private get title() {
    return this.$route.query.title;
  }

  public mounted() {
    const { src } = this.$route.query;

    src
      ? (this.src = src as string)
      : this.fetchVideo(this.$route.params.videoId);
  }
}
